import React , {useEffect, useState}from "react";
import {getFields} from "../../../../../dialog/formfields";
import {IconButton, Menu, MenuItem} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import MDBox from "../../../../../../components/MDBox";
import TabPageHeader from "../../header/tabpageheader";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import GenericForm from "../../../../../dialog/genericform";
import DataTableConfig from "../../../../../Tables/DataTableConfig";
import PropTypes from "prop-types";
import useConfigApi from "../../../../../utils/configapi";
import Endpoints from "../../../../../utils/endpoints";
import toast from "react-hot-toast";
import tableData from "../../../../../tabledata";

const EmvParamsConfig = ({ selectedRowData }) => {
    const { evmParamsConfigColumns } = tableData();
    const { evmParamsConfigFields } = getFields();
    const [evmParamsConfig, setEvmParamsConfig] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [activeRowIndex, setActiveRowIndex] = useState(null);
    const [isModalOpen, setModalOpen] = useState(false);
    const [dialogData, setDialogData] = React.useState(null);
    const [dialogMode, setDialogMode] = React.useState("edit");
    const [dialogTitle, setDialogTitle] = React.useState("Create EMV Params Config");
    const api = useConfigApi();

    const handleClick = () => {
        setDialogMode("create");
        setDialogData({});
        setModalOpen(true);
        setDialogTitle("Create EMV Params Config");

    };

    const closeModal = () => {
        setModalOpen(false);
        setDialogData(null);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setActiveRowIndex(null);
    };

    const handleMenuOpen = (event, index) => {
        setAnchorEl(event.currentTarget);
        setActiveRowIndex(index);
    };

    const handleActionClick = (action: string, item) => {
        const row = evmParamsConfig[activeRowIndex];
        if(action === 'View'){
            setModalOpen(true);
            setDialogMode("view");
            setDialogData(row);
            setDialogTitle("View EMV Params Config");
        } else if (action === 'Edit') {
            setModalOpen(true);
            setDialogMode("edit");
            setDialogTitle("Edit EMV Params Config");
            setDialogData(row);
        } else if (action === 'Delete') {
            setModalOpen(true);
            setDialogMode("delete");
            setDialogTitle("Delete EMV Params Config");
            setDialogData(row);
        }
        handleMenuClose();
    };

    const handleDialogSubmit = (formData) => {
        // console.log("Submitted data:", formData, dialogMode);
        formData.controlConfigSerialNumber  = selectedRowData.slNo;
        // Call your API here
        if (dialogMode === "create") {
            // Handle create logic here
            api.post(Endpoints.evmConfig.createOrUpdate, formData)
                .then((response) => {
                    toast.success("EMV config successfully created.");
                    fetchEVMConfigs(); // Fetch the latest data after creation
                })
                .catch((error) => {
                    toast.error("Internal error occurred while creating.");
                });
        } else if (dialogMode === "edit") {
            // console.log("Edited date:", formData, dialogMode);
            api.put(Endpoints.evmConfig.createOrUpdate, formData)
                .then((response) => {
                  toast.success("EMV config successfully updated.");
                  // fetchEVMConfigs(); // Fetch the latest data after editing
                  const updatedRow = response?.data?.data ?? formData;
                //   console.log("Updated Row:", updatedRow);
                setEvmParamsConfig(prevRows => {
                    return prevRows.map((row) =>
                        row?.slNo === updatedRow?.slNo ? { ...row, ...updatedRow } : row );
                    });
                // no refetch; order preserved
                })
                .catch((error) => {
                    console.log(error);
                    toast.error("Internal error occurred while updating.");
                });
        }
    };

    const handleDialogDelete = (formData) => {
        if (!formData.slNo) {
            toast.error("Missing slNo for deletion.");
            return;
        }
        api.delete(Endpoints.evmConfig.deleteBySlNo(formData.slNo))
            .then(() => {
                toast.success("EMV config successfully deleted.");
                fetchEVMConfigs();
            })
            .catch(() => {
                toast.error("Error deleting emv config.");
            });
    };

    useEffect(() => {
        fetchEVMConfigs();
    },[]);

    const fetchEVMConfigs = () => {
        api.get(Endpoints.evmConfig.getByControlSlNo(selectedRowData.slNo))
            .then((response) => {
                const data = response?.data.data || [];
                const modifiedData = data.map((item, index) => {
                    const action = (
                        <>
                            <IconButton onClick={(e) => handleMenuOpen(e, index)}>
                                <MoreHorizIcon />
                            </IconButton>
                        </>
                    );

                    return { ...item, action };
                });

                setEvmParamsConfig(modifiedData);
            })
            .catch((error) => {
                toast.error("Error while fetching records.");
            });
    };

    return <>
        <MDBox
            sx={{
                px: 3,
                py: 2,
                bgcolor: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
            }}
        >
            <TabPageHeader
                title="EMV Params Config"
                showButton={true}
                buttonLabel = "Add"
                onButtonClick={handleClick}

            />
        </MDBox>
        <MDBox sx={{
            px: 3,
            py: 2,
            bgcolor: "#fff",
            borderBottom: "1px solid #d3e3fd",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            overflowX: "auto",
            width: "100%",
        }}>


            <DataTableConfig
                table={{ columns : evmParamsConfigColumns, rows : evmParamsConfig }}
                showTotalEntries={true}
                isSorted={true}
                noEndBorder
                entriesPerPage={true}
                canSearch={true}
            />
        </MDBox>
        <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            onClick={handleMenuClose}
        >
            <MenuItem onClick={() => handleActionClick("View")}>
                <IconButton size="small">
                    <i className="material-icons">visibility</i>
                </IconButton>
                View
            </MenuItem>
            <MenuItem onClick={() => handleActionClick("Edit")}>
                <IconButton size="small">
                    <EditIcon fontSize="small" />
                </IconButton>
                Edit
            </MenuItem>
            <MenuItem onClick={() => handleActionClick("Delete")}>
                <IconButton size="small" color="error">
                    <DeleteIcon fontSize="small" />
                </IconButton>
                Delete
            </MenuItem>
            {/*<MenuItem onClick={() => handleActionClick("Sync")}>*/}
            {/*    <IconButton size="small" color="error">*/}
            {/*        <RefreshIcon fontSize="small" />*/}
            {/*    </IconButton>*/}
            {/*    Sync*/}
            {/*</MenuItem>*/}
        </Menu>
        <GenericForm
            open={isModalOpen}
            handleClose={closeModal}
            title={dialogTitle}
            fields={evmParamsConfigFields}
            onSubmit={handleDialogSubmit}
            onDelete={handleDialogDelete}
            initialData={dialogData}
            mode={dialogMode}
            useDialog={true}
        />
    </>
};

EmvParamsConfig.propTypes = {
    selectedRowData: PropTypes.shape({
        controlName: PropTypes.string,
        controlType: PropTypes.string,
        slNo: PropTypes.number,
    }),
};
export default EmvParamsConfig;
